import React from 'react';

import {Button, ModalPopup} from '@kit';

import {useCharacter} from '../character-context';
import type {JournalEntry} from '../model/character-state';

import css from './sheet.module.css';

type Props = {
	open: boolean;
	onClose(): void;
};

const timeFormat = new Intl.DateTimeFormat('ru', {hour: '2-digit', minute: '2-digit'});

const groupByDay = (entries: JournalEntry[]) => {
	const groups = new Map<string, JournalEntry[]>();
	for (const entry of entries) {
		const day = new Date(entry.time).toLocaleDateString('ru', {day: 'numeric', month: 'long', year: 'numeric'});
		groups.set(day, [...(groups.get(day) || []), entry]);
	}
	return [...groups];
};

export const JournalModal: React.FC<Props> = ({open, onClose}) => {
	const {state, update} = useCharacter();
	const entries = [...state.journal].reverse();

	return (
		<ModalPopup open={open} onClose={onClose} header="Журнал действий" maxWidth={640}>
			{entries.length ? (
				groupByDay(entries).map(([day, dayEntries]) => (
					<section key={day} className={css.journalDay}>
						<h3 className={css.groupTitle}>{day}</h3>
						<ul className={css.journal}>
							{dayEntries.map((entry) => (
								<li key={entry.id} className={css.journalEntry}>
									<span className={css.journalTime}>{timeFormat.format(entry.time)}</span>
									<span className={css.journalTitle}>
										{entry.title}
										{entry.details && <span className={css.muted}> {entry.details}</span>}
									</span>
									{entry.total != null && <b className={css.journalTotal}>{entry.total}</b>}
								</li>
							))}
						</ul>
					</section>
				))
			) : (
				<p className={css.muted}>Здесь появятся броски кубов и отдыхи.</p>
			)}
			<div className={css.modalButtons}>
				{entries.length > 0 && (
					<Button appearance="subtle" onClick={() => update({journal: []})}>
						Очистить журнал
					</Button>
				)}
				<Button appearance="primary" onClick={onClose}>
					Закрыть
				</Button>
			</div>
		</ModalPopup>
	);
};
